import React from "react";
import { Button, Form, Modal, Row, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { injectModels } from "../../../redux/injectModels";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { AdminFeedbackService } from "../../../services";
import { formatDateENGB } from "../../../utils/common-methods";
import { Routes } from "../../../constants";

function FeedbackList(props) {
  const navigate = useNavigate();
  const [showModal, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [activeRating, setActiveRating] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await AdminFeedbackService.getAllFeedbackProfiles();
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleEdit = async (profile) => {
    navigate(Routes.ADMIN_EDIT_TRADER, { state: { profile: profile } });
  };

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };
  const handleClose = () => {
    setShow(false);
  };

  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              {" "}
              <i className="fa-solid fa-chevron-right"></i>Feedbacks
            </li>
          </ol>
        </nav>
      </div>

      <div className="table-responsive">
        <div>
          <h2>All Feedbacks</h2>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Author</th>
              <th>Comment</th>
              <th>Rating</th>
              <th>To</th>
              <th>Created On</th>
              {/* <th>Status</th> */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx} style={{ verticalAlign: "middle" }}>
                      <td>{calculateSNo(idx)}</td>
                      <td>
                        <div>
                          <h5>{item?.objFromUser?.businessName}</h5>
                          {item?.objFromUser?.email}
                        </div>
                      </td>
                      <td>{<p>{item?.message}</p>}</td>
                      <td style={{ minWidth: 200 }}>
                        {[...Array(item?.rating ?? 0)].map((star, index) => {
                          const currentRating = index + 1;

                          return (
                            <label className="rating-control" key={index}>
                              <input
                                type="radio"
                                name="rating"
                                value={currentRating}
                              />
                              <span
                                className="star"
                                style={{
                                  color: "#ffc107",
                                  //currentRating <= 2 ? "#ffc107" : "#e4e5e9"
                                }}
                              >
                                &#9733;
                              </span>
                            </label>
                          );
                        })}
                      </td>
                      <td>
                        <div>
                          <h5>{item?.objToUser?.businessName}</h5>
                          {item?.objToUser?.email}
                        </div>
                      </td>

                      <td>{formatDateENGB(item?.createdOn)}</td>
                      {/* <td
                        className="delete-create"
                        style={{ textAlign: "center" }}
                      >
                        {item.isActive === true ? (
                          <i className="ri-close-circle-line"></i>
                        ) : (
                          <i className="ri-check-fill"></i>
                        )}
                      </td> */}
                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveRating(item);
                              setShow(true);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="fa-solid fa-eye"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <p className="mb-3">
          <strong>Total Count: {filteredData.length}</strong>
        </p>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
      <Modal show={showModal} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>Review details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {[...Array(activeRating?.rating ?? 0)].map((star, index) => {
            const currentRating = index + 1;

            return (
              <label className="rating-control" key={index}>
                <input type="radio" name="rating" value={currentRating} />
                <span
                  className="star"
                  style={{
                    color: "#ffc107",
                    //currentRating <= 2 ? "#ffc107" : "#e4e5e9"
                  }}
                >
                  &#9733;
                </span>
              </label>
            );
          })}
          <Form aria-disabled="true" style={{ flex: 1 }}>
            <fieldset disabled>
              <Row className="mb-3">
                <Form.Group>
                  <Form.Label>Author</Form.Label>
                  <Form.Control
                    defaultValue={activeRating?.objFromUser?.businessName}
                  />
                </Form.Group>
                <Form.Group>
                  {/* <Form.Label>Author email</Form.Label> */}
                  <Form.Control
                    defaultValue={activeRating?.objFromUser?.email}
                  />
                </Form.Group>
              </Row>

              <Form.Group className="mb-3" controlId="formGridAddress1">
                <Form.Label>Comment</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  disabled
                  defaultValue={activeRating?.message}
                />
              </Form.Group>

              <Form.Group controlId="formGridBusinessInfo">
                <Form.Label>To</Form.Label>
                <Form.Control
                  defaultValue={activeRating?.objToUser?.businessName}
                />
              </Form.Group>
              <Form.Group>
                {/* <Form.Label>email</Form.Label> */}
                <Form.Control defaultValue={activeRating?.objToUser?.email} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Review date</Form.Label>
                <Form.Control
                  defaultValue={formatDateENGB(activeRating?.createdOn)}
                />
              </Form.Group>
            </fieldset>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(FeedbackList);
